import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";
import { cn } from "@/lib/utils";

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle = ({ className }: ThemeToggleProps) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={cn(
        "inline-flex h-8 w-8 items-center justify-center rounded-full border border-border bg-card shadow-sm backdrop-blur-sm transition-transform hover:scale-105",
        className,
      )}
    >
      {isDark ? (
        <Sun aria-hidden="true" className="h-3.5 w-3.5 fill-[hsl(48_96%_53%)] text-[hsl(48_96%_53%)]" />
      ) : (
        <Moon aria-hidden="true" className="h-3.5 w-3.5 fill-[hsl(220_39%_11%)] text-[hsl(220_39%_11%)]" />
      )}
    </button>
  );
};

export default ThemeToggle;
